
import { Options, Vue } from 'vue-class-component'
import { useStore } from '@/store'

@Options({
  computed: {
    modalOptions() {
      return this.$store.state.modalNotification.modalOptions
    },
  }
})
export default class ModalBottomNotification extends Vue {
  private store = useStore()
	private active = true

	mounted() {
    this.setOpacity()
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName('dummy-background-notification')[0]! as HTMLElement
    setTimeout(() => { modalElement.style.opacity = '0.7' }, 10)
  }

	closeModal() {
    const dialogElement = document.getElementsByClassName('modal-dialog')[0]! as HTMLElement
    const modalElement = document.getElementsByClassName('dummy-background-notification')[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'

    setTimeout(() => {
      this.store.dispatch('modalNotification/onClose')
    }, 500)
	}
}
